import { render, staticRenderFns } from "./BaseMap.vue?vue&type=template&id=50ea3d4b&"
import script from "./BaseMap.vue?vue&type=script&lang=js&"
export * from "./BaseMap.vue?vue&type=script&lang=js&"
import style0 from "./BaseMap.vue?vue&type=style&index=0&id=50ea3d4b&lang=css&"
import style1 from "leaflet-gesture-handling/dist/leaflet-gesture-handling.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50ea3d4b')) {
      api.createRecord('50ea3d4b', component.options)
    } else {
      api.reload('50ea3d4b', component.options)
    }
    module.hot.accept("./BaseMap.vue?vue&type=template&id=50ea3d4b&", function () {
      api.rerender('50ea3d4b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseMap.vue"
export default component.exports